import GameStatesEnum from "../GameStatesEnum"
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";

export default class ShowCycleWinningsState extends BaseState {

  begin() {
    if(this.model.stateSkipped) {
      this.end()
      return
    }
    Signals.showWinningsComplete.addOnce(this.end)
    Signals.spinBtnPressed.addOnce(this.skip, this)
    Signals.startShowCycleWinnings.dispatch({winnings: this.model.winnings, bonus: this.model.bonus})
    Signals.buyBtnPressed.add (this.endBuy, this)
  }

  end = () => {
    this.model.scatters = false
    this.model.winnings = null
    this.gameState = GameStatesEnum.FINAL
    this.stateMachine.setState(this.gameState)
	}

  skip() {
    Signals.spinBtnPressed.remove(this.skip, this)
    this.model.stateSkipped = true
    Signals.skip.dispatch()
  }

  endBuy = () => {
    let gameState = GameStatesEnum.GET_BUY_FREESPIN_RESPONSE
    this.model.scatters = false
    this.model.winnings = null
    this.cleanUp()
    Signals.skipForBuy.dispatch()
    Signals.showWinningsComplete.dispatch()
    this.stateMachine.setState(gameState);
  }

  cleanUp() {
    Signals.showWinningsComplete.remove(this.end, this)
    Signals.spinBtnPressed.remove(this.skip, this)
    Signals.buyBtnPressed.remove (this.endBuy, this)
  }
}